import React, { useState, useRef } from "react";
import QRCode from 'qrcode.react';
import { toPng } from 'html-to-image';
import { authActions } from "../../../store/auth";
import { useDispatch } from "react-redux";
import { endPoints } from "../../../config/end-points";
import useHttp from "../../../hooks/use-http";

const QrCodeModal = ({
    setShowQrCodeModal, setImgbtnData, ImgbtnData
  }) => {

    
  const [text, setText] = useState('');
  const handleInputChange = (e) => {
    setText(e.target.value);
  };
  const dispatch = useDispatch();
  const {sendRequest: saveImage} = useHttp();
  const qrCodeRef = useRef(null);


  const saveImageAsync = async (dataUrl) => {
    
      
    await saveImage({
        url: endPoints.saveImageData,
        method: "POST",
        body: {
          imgData: dataUrl,
          camp_id: 0,
        }
    },
    (response) => {
      console.log(response);
      if(response.url && response.url.length > 0){
        setImgbtnData({
          ...ImgbtnData,
          ImgbtnURL: response.url,
        })
      }
      
      
    });
      
    
  };

  const handleSaveImage = () => {
    dispatch(authActions.setLoaderStatus({ status: true, loader_text: "Generating QR Code... Please Wait" }));
    if (qrCodeRef.current) {
      toPng(qrCodeRef.current)
        .then( async (dataUrl) => {

          await saveImageAsync(dataUrl);
          setShowQrCodeModal(false);
          dispatch(authActions.setLoaderStatus({ status: false , loader_text: ""}));

        })
        .catch((error) => {
          dispatch(authActions.setLoaderStatus({ status: false }));
          console.error('Error saving QR code as image:', error);
        });
    }else{
      dispatch(authActions.setLoaderStatus({ status: false, loader_text: "" }));
    }

  };

  return (
    <div
      className="modal fade show d-block"
      id="modalcreatevideo"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="modalcreatevideoTitle"
      aria-hidden="true"
    >
      <div
        className="modal-dialog modal-dialog-centered modal-md"
        role="document"
      >
        <div className="modal-content">
          <div className="modal-header">
            <h3>Generate QR Code</h3>
            <button
              type="button"
              className="close"
              onClick={() => {
                setShowQrCodeModal(false);
              }}
            >
              <i
                className="fas fa-times"
                style={{ fontSize: "20px", color: "#cacccf" }}
              ></i>
            </button>
          </div>
          <div className="modal-body">
            <div className="row">
              <div className="col-12 text center">

                <div className="d-flex justify-content-center mt-3">
                  {text && (
                    <div ref={qrCodeRef}>
                      <QRCode value={text} />
                    </div>
                  )}
                </div>
                     
              <div>
                <label className="mt-4" htmlFor="text-input">Enter Your Text or Redirect URL:</label>
                <input
                  className="form-control mt-3 mb-2"
                  type="text"
                  id="text-input"
                  value={text}
                  onChange={handleInputChange}
                />

                <p className="text-center mb-4"><span className="text-danger">*Note:</span> When a user will scan this QR Code he will see the Text or redirect URL you entered here</p>


                {text && ( <button className="btn btn2" onClick={handleSaveImage}> Save </button> )}
              </div>


                
              </div>
              <div className="col-6">
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QrCodeModal;
